module.exports = __webpack_public_path__ + "static/img/lotte-thumb.ee57be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lotte-thumb.jpg
// module id = JUbB
// module chunks = 0